import documentsmanagement from '@/shared/http/repositories/realestate/documentsmanagement'
import EnterpriseRepository from '@/shared/http/repositories/realestate/enterprise'
import {mask} from 'vue-the-mask'
import { toast, loading } from '@/shared/utils/UIHelper'
import usermanagement from '@/shared/http/repositories/realestate/usermanagement'

export default {
  name: 'AddDocumentButton',
  data () {
    return {
      file: [],
      enterprises: [],
      documentName: '',
      opDestiny: 0,
      customerCpf: '',
      enterpriseSelected: '',
      customerSelected: {},
      nameInput: ''

    }
  },
  methods: {
    openUploadPopup () {
      this.$refs['add-document-modal'].show()
      document.querySelector('#impor-pdf').value = ''
      this.nameInput = ''
    },
    closeUploadPopup () {
      this.$refs['add-document-modal'].hide()
      document.querySelector('#impor-pdf').value = ''
      this.nameInput = ''
    },
    GetValueFile (e) {
      this.nameInput = e.target.files[0].name
      this.file = e.target.files[0]
    },
    openFilePdf () {
      document.getElementById('impor-pdf').click()
    },
    searchCustomer () {
      usermanagement.GetClienteByCpf(this.customerCpf.replace(/[().-]/gm, ''))
        .then(res => {
          if (res.status === 200) {
            if (res.data.data.nome != null) {
              this.customerSelected = res.data.data
              this.customerSelected['find'] = true
              return
            }
            this.customerSelected['nome'] = 'Cliente não encontrado'
            this.customerSelected['find'] = false
          }
        })
        .catch(() => {
          this.customerSelected['nome'] = 'Ocorreu um erro'
        })
    },
    displayWarning (text) {
      toast.info(text)
      loading.close()
    },
    uploadNewDocument () {
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      if (this.file.length === 0) {
        this.displayWarning('Selecione um arquivo antes de enviar')
        return
      }
      let data = new FormData()
      data.append('arquivo', this.file)

      if (this.opDestiny === '1') {
        data.append('empreendimentoId', this.enterpriseSelected)
      }

      if (this.opDestiny === '2') {
        if (!this.customerSelected.find) {
          this.displayWarning('Por favor, selecione um cliente.')
          return
        }
        data.append('clienteId', this.customerSelected.id)
      }
      documentsmanagement.UploadDocumento(data, conf)
        .then(res => {
          if (res.status === 200) {
            if (res.data.data != null) {
              this.closeUploadPopup()
              this.file = []
              this.customerCpf = ''
              this.enterpriseSelected = ''
              this.customerSelected = {}
              this.$emit('updateTableDocuments')
              toast.success('Documento enviado com sucesso')
              loading.close()
            }
          }
        })
        .catch(() => {
          toast.error('Erro ao enviar documento')
          loading.close()
        })
    }
  },
  mounted () {
    EnterpriseRepository.GetAll()
      .then(res => {
        if (res.status === 200) {
          this.enterprises = res.data.data
        }
      })
      .catch(res => console.log(res))
  },
  directives: {mask}
}



// WEBPACK FOOTER //
// ./src/views/private/documentsManagement/components/AddDocumentButton/AddDocumentButton.js